<template>
  <div class="bg-white py-8 menucontrol-scroll w-full fixed-top">
    <!-- <div class="w-2/5 pl-6 pr-4">
        <Plans />
      </div> -->
    <div class="px-6 pb-8">
      <EcommerceOption
        v-if="
          modules.filter(
            (x) =>
              (typeof x == 'object' &&
                ['Admin', 'Developer'].includes(login.role) &&
                x.extensionId &&
                x.extensionId.name === 'Ecommerce' &&
                x.status === 'Active') ||
              x === 'Ecommerce'
          ).length
        "
      />
      <!-- <CMSOption
        v-if="
          ['Admin', 'Developer'].includes(login.role) || modules.filter((x) => x === 'CMS').length
        "
      /> -->

      <!-- <UserManagmentOption /> -->

      <PerformanaceOption
        v-if="
          ['Admin', 'Developer'].includes(login.role) ||
          modules.filter((x) => x === 'Performance').length
        "
      />
      <!-- v-if="
            modules.filter(
              (x) =>
                x.extensionId &&
                x.extensionId.name === 'Setting' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(login.role)
            ).length
          " -->
      <SettingsOption
        v-if="
          ['Admin', 'Developer'].includes(login.role) ||
          multiLineArray(allModules, userModules)
        "
      />
    </div>
  </div>
</template>

<script>
import EcommerceOption from "./EcommerceOption";
import CMSOption from "./CMSOption";
import UserManagmentOption from "./UserManagmentOption";
import PerformanaceOption from "./PerformanaceOption";
import SettingsOption from "./SettingsOption";
import { mapState } from "vuex";
export default {
  components: {
    EcommerceOption,
    CMSOption,
    UserManagmentOption,
    PerformanaceOption,
    SettingsOption,
  },

  data() {
    return {
      modules: [],
    };
  },

  computed: {
    ...mapState("admin", ["userModules", "login", "allModules"]),
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    async getExtensions() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "Extensions/getExtensionRequest",
        payload
      );
      if (this.userModules) {
        this.modules = [...data.data, ...this.userModules];
      } else {
        this.modules = [...data.data];
      }
    },

    multiLineArray(arr, values) {
      let array = values.filter((x) => typeof x === "string");
      return array.some((value) => {
        return arr.includes(value);
      });
    },
  },
  async mounted() {
    this.$vs.loading();
    // await this.$store.dispatch("project/getModules");
    await this.getExtensions();
    this.$vs.loading.close();
  },
};
</script>
